import script from "./CadastroEquipamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroEquipamentos.vue?vue&type=script&setup=true&lang=js"

import "./CadastroEquipamentos.vue?vue&type=style&index=0&id=cbf9dafe&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbf9dafe"]])

export default __exports__